import { CssBaseline, ThemeProvider } from "@mui/material";
import React, { useEffect } from "react";
import { SnackbarProvider } from "notistack";
// import theme from "./Main/theme";
import { Provider as ReduxProvider } from "react-redux";
import { store } from "./redux/store";
import { BrowserRouter } from "react-router-dom";
import Main from "./Main/Main";
import config from "./config";

import "./style.css";
import theme from "./Main/theme";
import { PersistGate } from "redux-persist/integration/react";
import { persistStore } from "redux-persist";
import { ConfirmProvider } from "material-ui-confirm";
import GlobalLoader from "./Main/GlobalLoader";

let persistor = persistStore(store);
// import config from './config';

function WrapPersist({
  persist,
  children,
}: {
  persist: boolean;
  children: any;
}) {
  if (persist) {
    return (
      <PersistGate loading={null} persistor={persistor}>
        {children}
      </PersistGate>
    );
  }
  return children;
}

function App() {
  // DJT++ 17032025
  useEffect(() => {
    if (window.self !== window.top) {
      document.body.innerHTML =
        "<h1>Clickjacking detected! This site cannot be embedded.</h1>";
    }
  }, []);

  useEffect(() => {
    // Disable right-click (context menu)
    const handleRightClick = (e: { preventDefault: () => void }) => {
      e.preventDefault();
    };

    // Disable copy, cut, and paste
    const handleCopyCutPaste = (e: { preventDefault: () => void }) => {
      e.preventDefault();
    };

    // Add event listeners for right-click and copy-paste
    document.addEventListener("contextmenu", handleRightClick);
    document.addEventListener("copy", handleCopyCutPaste);
    document.addEventListener("cut", handleCopyCutPaste);
    document.addEventListener("paste", handleCopyCutPaste);

    // Clean up event listeners when the component unmounts
    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
      document.removeEventListener("copy", handleCopyCutPaste);
      document.removeEventListener("cut", handleCopyCutPaste);
      document.removeEventListener("paste", handleCopyCutPaste);
    };
  }, []);

  return (
    <div>
      <ReduxProvider store={store}>
        <ConfirmProvider>
          <WrapPersist persist={config.PERSIST_STORE}>
            <ThemeProvider theme={theme}>
              <SnackbarProvider maxSnack={3} autoHideDuration={5000}>
                <CssBaseline />
                <BrowserRouter basename={config.BASEPATH}>
                  <Main />
                </BrowserRouter>
              </SnackbarProvider>
            </ThemeProvider>
          </WrapPersist>
        </ConfirmProvider>
      </ReduxProvider>
      <GlobalLoader />
    </div>
  );
}

export default App;
